"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export default function useHasTouchInput() {
  const $ = _c(3);
  const [hasTouchInput, setHasTouchInput] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== hasTouchInput) {
    t0 = () => {
      if (typeof globalThis === "undefined") {
        return;
      }
      if (hasTouchInput) {
        return;
      }
      const onTouchStart = () => {
        setHasTouchInput(true);
        globalThis.removeEventListener("touchstart", onTouchStart);
      };
      globalThis.addEventListener("touchstart", onTouchStart, {
        passive: true
      });
      return () => {
        globalThis.removeEventListener("touchstart", onTouchStart);
      };
    };
    t1 = [hasTouchInput];
    $[0] = hasTouchInput;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return hasTouchInput;
}
function _temp() {
  if (typeof globalThis === "undefined") {
    return false;
  }
  const nav = globalThis.navigator as Navigator | undefined;
  return (nav?.maxTouchPoints ?? 0) > 0;
}